import { camelCase } from "change-case";

import { Schematic } from "../../Schematic";
import { ScaffoldingData } from "../ScaffoldingData";
import serializerKt from "../templates/Serializer.kt.ejs?raw";
import { addEjsTemplateFile } from "../templating/util/addEjsTemplateFile";

export function scaffoldSerializer(
  schematic: Schematic,
  data: ScaffoldingData,
) {
  addEjsTemplateFile(data, `${schematic.name}Serializer.kt`, serializerKt, {
    filePackage: data.currentPackage,
    formVar: camelCase(schematic.name!),
    formClass: schematic.name,
  });
}
